<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Özellik Düzenle <small>( {{ title }} )</small></h3>
            </div>
            <div class="row">

               <div class="col-md-6">
                <div class="form-group">
                  <label for="category">Kategorisi</label>
                  <select class="form-control custom-input" v-model="category">
                    <option v-for="category in categories" :key="category.id" :value="category.id" >{{ category.title }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="title">Özellik Adı</label>
                  <input
                    type="text"
                    v-model="title"
                    class="form-control custom-input"
                  >
                </div>
              </div>


              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="updateData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                id: this.$route.params.id,
                title: '',
                category: '',
                categories: [],
                api: 'dorm_properties/',

            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                this.$Progress.start()
                this.axios.get(this.api + this.id + '/edit').then(response => {
                    this.title = response.data.data.title
                    this.category = response.data.data.category_id
                    this.categories = response.data.categories
                    this.$Progress.finish()
                })
            },
            updateData() {
                this.$Progress.start()
                this.axios.put(this.api + this.id, {
                    category: this.category,
                    title: this.title,
                  // eslint-disable-next-line no-unused-vars
                }).then(response => {
                    // console.log(response);
                    this.$Progress.finish()
                })
            }
        },
    }
</script>

<style scoped>

</style>
